import { makeStyles, Typography } from '@material-ui/core';
import FormSection from 'components/Shared/FormSection';
import RoleSelector from './RoleSelector';
import USER_ROLES from 'components/Users/constants';

const useStyles = makeStyles((theme) => ({
  providerFieldsContainer: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
    borderRadius: 8,
    border: '1px solid rgba(0, 168, 255, 0.1)',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      background: 'linear-gradient(90deg, #5B65DC 0%, #6C7FDF 100%)',
      borderRadius: '8px 8px 0 0',
    },
  },
  providerFieldsTitle: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    '&::before': {
      content: '"✓"',
      marginRight: theme.spacing(1),
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  inputField: {
    width: '100%',
    padding: 10,
    border: '1px solid #e1e4e8',
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
    },
  },
  inputLabel: {
    display: 'block',
    marginBottom: 8,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: '0.75rem',
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(0),
  },
  inputError: {
    borderColor: theme.palette.error.main,
    '&:focus': {
      borderColor: theme.palette.error.main,
      boxShadow: `0 0 0 2px ${theme.palette.error.main}20`,
    },
  },
}));

const UserRoleDetailsSection = ({ formik, currentAccount, backendErrors }) => {
  const classes = useStyles();


  return (
    <FormSection title="User Role Details">
      <RoleSelector
        value={formik.values.role}
        onChange={(value) => formik.setFieldValue('role', value)}
        forms={{
          provider: 'Provider',
          assistant: 'Assistant'
        }}
      />

      {formik.values.role === USER_ROLES.PROVIDER && (
        <div className={classes.providerFieldsContainer}>
          <Typography className={classes.providerFieldsTitle}>
            Provider Information Required
          </Typography>
          <div style={{ marginBottom: 20 }}>
            <label className={classes.inputLabel}>
              Provider Title
            </label>
            <input
              type="text"
              placeholder="e.g., MD, DO, NP"
              value={formik.values.providerTitle}
              onChange={(e) => formik.setFieldValue('providerTitle', e.target.value)}
              className={`${classes.inputField} ${backendErrors && (backendErrors?.providerTitle  || backendErrors['permissions.providerTitle']) ? classes.inputError : ''}`}
            />
            {backendErrors && (backendErrors?.providerTitle || backendErrors['permissions.providerTitle']) && (
              <Typography className={classes.errorText}>
                {backendErrors.providerTitle  || backendErrors['permissions.providerTitle']}
              </Typography>
            )}
          </div>

          <div>
            <label className={classes.inputLabel}>
              NPI Number
            </label>
            <input
              type="text"
              placeholder="10-digit NPI number"
              value={formik.values.providerNPINumber}
              onChange={(e) => formik.setFieldValue('providerNPINumber', e.target.value)}
              className={`${classes.inputField} ${backendErrors && (backendErrors?.providerNPINumber || backendErrors['permissions.providerNPINumber']) ? classes.inputError : ''}`}
            />
            {backendErrors && (backendErrors?.providerNPINumber || backendErrors['permissions.providerNPINumber']) && (
              <Typography className={classes.errorText}>
                {backendErrors.providerNPINumber || backendErrors['permissions.providerNPINumber']}
              </Typography>
            )}
          </div>
        </div>
      )}
    </FormSection>
  );
};

export default UserRoleDetailsSection;
